module.exports = (__parcel__import__("ft2Sf")).then(() => parcelRequire('fyWP3'));